const keyUri = {
//BACKEND_URI:'http://localhost:5000'
  // Development URL

//BACKEND_URI: "https://squid-app-9qp4x.ondigitalocean.app"

  // Production URL
  
  
BACKEND_URI:"https://production-goldfish-app-7oxlf.ondigitalocean.app"



};

/*let token = localStorage.getItem("token");
const config = {
  headers: {
    Accept: "application/json",
    Authorization: `Bearer ${token}`,
  },
};

export { keyUri, config }; */

const storedToken = localStorage.getItem('authToken') ? localStorage.getItem('authToken') : null;
const storedUserToken = localStorage.getItem('tokenuser') ? localStorage.getItem('tokenuser') : null;
console.log("stored", storedToken);
console.log("stored user Token", storedUserToken);
const token = storedToken ? storedToken : null;
const usertoken = storedUserToken ? storedUserToken.slice(1, -1) : null;

const config = {
    
    headers: {
    Accept: "application/json",
    // Authorization: token ? `Bearer ${token}`: undefined ||usertoken?`Bearer ${usertoken}`: undefined ,
    //commit 
Authorization: (token ? `Bearer ${token}` : (usertoken ? `Bearer ${usertoken}` : undefined))    

}


}; 

export { keyUri, config };
